import { cn } from 'src/shared/utils/cn'

interface BusinessFormTitleProps {
  children: React.ReactNode
  className?: string
}

export default function BusinessFormTitle({ children, className }: BusinessFormTitleProps) {
  return (
    <div className={cn('text-center text-[30px] font-semibold text-primary md:text-[36px]', className)}>{children}</div>
  )
}
